import React, { useEffect, useRef, useState } from "react"
import { motion } from "framer-motion"
import slides from "./SlideItems"
import "./slider.css"

function Slider() {
  const [width, setWidth] = useState(0)
  const slider = useRef(null)

  useEffect(() => {
    setWidth(slider.current.scrollWidth - slider.current.offsetWidth)
  }, [width])

  return (
    <section
      data-scroll-section
      className="container-fluid section-container slider-container"
    >
      <motion.div
        ref={slider}
        className="slider"
        whileTap={{ cursor: "grabbing" }}
      >
        <motion.div
          drag="x"
          dragConstraints={{ right: 0, left: -width }}
          className="slider-inner"
        >
          {slides.map((slide) => (
            <motion.div key={slide.title} className="slide">
              <img src={slide.image} alt="" />
              <h1 className="serif-2">
                {slide.title} <span className="serif">{slide.span}</span>
              </h1>
              <p>{slide.detail}</p>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  )
}

export default Slider
